import React, { useContext, useEffect, useState } from 'react';
import { Grid, Paper, Typography, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { LanguageContext } from '../../../../libs/Context';
import { feedActionContext } from '../../index';
import { catchErr } from '../../../../libs/HelperContent';
import { undoReportFeed } from '../../../actions/feeds_actions_new';
import { toast } from 'react-toastify';
import Loading from '../../../../components/Common/Loaders/FullWidthLoader/Loading';

const Notification = () =>
{
	const { language } = useContext(LanguageContext);

	const { feedAction, handleFeedAction } = useContext(feedActionContext);
	const [ loading, setLoading ] = useState<boolean>(false);

	const showReport = feedAction?.report_tag;

	const handleUndo = async () =>
	{
		if (!loading)
		{
			setLoading(true);
			try
			{
				const body = {
					reportId : showReport?.reportId,
					feedId   : showReport?._id
				};
				const res = await undoReportFeed(body);

				if (res?.status)
				{
					toast.success(language.feedUpdatedSuccesfully, {
						position  : toast.POSITION.TOP_RIGHT,
						className : 'toast-message'
					});
					setLoading(false);
					const newObj = { ...showReport };

					delete newObj.reportId;

					handleFeedAction('append', 'new_feed', newObj);
					handleFeedAction('remove', 'report_tag');
				}
			}
			catch (err)
			{
				catchErr(err);
				setLoading(false);
			}
		}
	};

	const closeTag = () =>
	{
		handleFeedAction('remove', 'report_tag');
	};

	useEffect(() =>
	{
		const timer = setTimeout(() =>
		{
			closeTag();
		}, 60000);

		return () => clearTimeout(timer);
	}, []);

	return (
		<Grid item xs={12}>
			{loading && <Loading/>}
			<Paper elevation={1} sx={{ p: 'var(--pixel8)', width: 'var(--percent100)', border: '1px solid rgba(117, 191, 120, 1)', borderRadius: 'var(--pixel8)', backgroundColor: '#d6edd770' }}>
				<Grid container alignItems='center' flexWrap='nowrap' spacing={1}>
					<Grid item xs sx={{
						display    : 'flex',
						alignItems : 'center',
						overflow   : 'hidden',
						minWidth   : 0
					}}
					>
						<Typography
							variant='body2'
							sx={{
								flexGrow     : 1,
								whiteSpace   : 'nowrap',
								overflow     : 'hidden',
								textOverflow : 'ellipsis'
							}}
						>
							<strong>{language?.reporting} </strong>,
							{language?.lettingUsKnow}
						</Typography>
					</Grid>
					<Grid item>
						<Typography variant='inherit' fontSize={'var(--pixel16)'} fontWeight='var(--font500)' color={'var(--primaryColor)'}
							sx={{ cursor: 'pointer' }} onClick={handleUndo}
						>{language?.undo}</Typography>
					</Grid>
					<Grid item>
						<IconButton size='small' onClick={closeTag}>
							<CloseIcon sx={{ cursor: 'pointer', fontSize: 'var(--pixel20)' }}/>
						</IconButton>
					</Grid>
				</Grid>
			</Paper>
		</Grid>
	);
};

export default Notification;
